import { render } from "./ReadMoreText.vue?vue&type=template&id=1712e532"
import script from "./ReadMoreText.vue?vue&type=script&lang=js"
export * from "./ReadMoreText.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__